export const LOGO_X = 710;
export const LOGO_Y = 59.24;
export const LOGO_WIDTH = 500;
export const LOGO_HEIGHT = 60;
export const PICTURE_X = 795.14;
export const PICTURE_Y = 310;
export const PICTURE_WIDTH = 331;
export const PICTURE_HEIGHT = 300;

export const TITLE_START_Y = 668;
export const TITLE_FONT = '700 48px "YS Text", sans-serif';

export const TEXT_START_Y = 740;
export const TEXT_FONT = '500 28px "YS Text", sans-serif';

export const CONFERENCE_START_Y = 991;
export const CONFERENCE_FONT = '500 28px "YS Text", sans-serif';
